import * as elements from './elements.js'
import _ from 'lodash'

// Theme animation with Green Sock

// Import GSAP
import { gsap } from 'gsap'

// Import GSAP ScrollTrigger plugin
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)
gsap.config({ nullTargetWarn: false }) // Hide warning if target not find

/* Page
------------------------------------------------------------------------ */

/** Menu & header **/
var menu_timeline = gsap.timeline({ repeat: 0, duration: 0.2 })

if (document.body.classList.contains('home')) {
    menu_timeline.fromTo('.home .logo', { y: -200 }, { y: 0 })
    menu_timeline.fromTo('.home #menu-primary-desktop-wrapper', { y: -100 }, { y: 0 })
}

if (window.matchMedia('(min-width: 1200px)').matches) {
    menu_timeline.fromTo('h1', { x: -100, opacity: 0 }, { x: 0, opacity: 1 }, '-=0.2')
    menu_timeline.fromTo('h1 + p', { x: -100, opacity: 0 }, { x: 0, opacity: 1 }, '-=0.2')
    menu_timeline.fromTo('h1 + p + p', { x: -100, opacity: 0 }, { x: 0, opacity: 1 }, '-=0.1')
}
/** Block: Media & text **/
const ratio = 0.3
const options = {
    root: null,
    rootMargin: '0px',
    threshold: ratio,
}

const callback = (entries, observer) => {
    entries.forEach((entry, index) => {
        let figureEl = entry.target.querySelector('figure')
        let textEl = entry.target.querySelector('div')

        if (window.matchMedia('(min-width: 1200px)').matches) {
            figureEl.style.cssText = 'opacity: 0; transform: scale(0)'
            textEl.style.cssText = 'opacity: 0; transform: translate(300px, 0)'
        }

        if (entry.intersectionRatio > ratio) {
            if (window.matchMedia('(min-width: 1200px)').matches) {
                gsap.to([textEl], { opacity: 1, x: 0, y: 0 })
                gsap.to([figureEl], { opacity: 1, scale: 1 })
            }

            observer.unobserve(entry.target)
        }
    })
}

let observer = new IntersectionObserver(callback, options)

elements.mediaText.forEach((element) => {
    let mediaEl = element.querySelector('.wp-block-media-text__media')

    if ('IntersectionObserver' in window) {
        observer.observe(mediaEl.parentNode)
    } else {
        return
    }
})

/** Block: columns with video **/
const callbackColumnsWithVideo = (entries, observer) => {
    entries.forEach((entry, index) => {
        const tl = gsap.timeline({ repeat: 0 })

        const rightSideVideo = entry.target.querySelector('.wp-block-column:nth-child(2) > .wp-block-video')

        if (window.matchMedia('(min-width: 1200px)').matches) {
            rightSideVideo.style.cssText = 'opacity: 0; transform: translate(0, -300px)'
        }

        if (entry.intersectionRatio > ratio) {
            if (window.matchMedia('(min-width: 1200px)').matches) {
                tl.to(rightSideVideo, { opacity: 1, y: 0 }, '-=0.2')
                tl.play()
            }
            observer.unobserve(entry.target)
        } else {
            tl.paused(true)
        }
    })
}
let observerColumnsWithVideo = new IntersectionObserver(callbackColumnsWithVideo, options)
elements.mediaColumns.forEach((element) => {
    if ('IntersectionObserver' in window) {
        observerColumnsWithVideo.observe(element)
    } else {
        return
    }
})

/** Block: columns **/
const callbackBlockColumns = (entries, observer) => {
    entries.forEach((entry, index) => {
        const columns = entry.target

        if (window.matchMedia('(min-width: 1200px)').matches) {
            columns.style.cssText = 'opacity:0; transform:translate(0,100px)'
        }

        if (entry.intersectionRatio > ratio) {
            if (window.matchMedia('(min-width: 1200px)').matches) {
                gsap.to([columns], { opacity: 1, y: 0 })
            }

            observer.unobserve(columns)
        }
    })
}

let observerBlocksColumns = new IntersectionObserver(callbackBlockColumns, options)

elements.blockColumns.forEach((element) => {
    if ('IntersectionObserver' in window) {
        observerBlocksColumns.observe(element)
    } else {
        return
    }
})

/** Block: cover **/
const callbackBlockCover = (entries, observer) => {
    entries.forEach((entry, index) => {
        const cover = entry.target
        const innerContainer = cover.querySelector('.wp-block-cover__inner-container')

        if (window.matchMedia('(min-width: 1200px)').matches) {
            cover.style.cssText = 'opacity:0; transform:translate(0,-100px)'
            innerContainer.style.cssText = 'opacity:0; transform:translate(100px,-100px)'
        }

        if (entry.intersectionRatio > ratio) {
            if (window.matchMedia('(min-width: 1200px)').matches) {
                gsap.to([cover], { opacity: 1, y: 0 })
                gsap.to([innerContainer], { opacity: 1, y: 0, x: 0 }, '>=0.5')
            }
            observer.unobserve(cover)
        }
    })
}

let observerBlocksCover = new IntersectionObserver(callbackBlockCover, options)

elements.blockCover.forEach((element) => {
    if ('IntersectionObserver' in window) {
        observerBlocksCover.observe(element)
    } else {
        return
    }
})

/** Block: kblocks **/
const callbackKBlocks = (entries, observer) => {
    entries.forEach((entry, index) => {
        const blocks = entry.target
        const allBlock = blocks.querySelectorAll('.card')

        allBlock.forEach((block, index) => {
            if (window.matchMedia('(min-width: 1200px)').matches) {
                blocks.style.cssText = 'overflow:hidden'
                block.style.cssText = 'opacity:0; transform:translate(0,100px)'
            }

            if (entry.intersectionRatio > ratio) {
                if (window.matchMedia('(min-width: 1200px)').matches) {
                    gsap.to([block], { opacity: 1, y: 0, delay: index / 15 })
                }
                observer.unobserve(blocks)
            }
        })
    })
}

let observerKBlocks = new IntersectionObserver(callbackKBlocks, options)

elements.kBlocks.forEach((element) => {
    if ('IntersectionObserver' in window) {
        observerKBlocks.observe(element)
    } else {
        return
    }
})

/** Block: trainings **/
const callbackTrainings = (entries, observer) => {
    entries.forEach((entry, index) => {
        const trainings = entry.target
        const AlltrainingCard = trainings.querySelectorAll('.training-card')

        AlltrainingCard.forEach((card, index) => {
            if (window.matchMedia('(min-width: 1200px)').matches) {
                trainings.style.cssText = 'overflow:hidden'
                card.style.cssText = 'opacity:0; transform:translate(0,100px)'
            }

            if (entry.intersectionRatio > ratio) {
                if (window.matchMedia('(min-width: 1200px)').matches) {
                    gsap.to([card], { opacity: 1, y: 0, delay: index / 15 })
                    observer.unobserve(trainings)
                }
            }
        })
    })
}

let observerTrainings = new IntersectionObserver(callbackTrainings, options)

elements.trainings.forEach((element) => {
    if ('IntersectionObserver' in window) {
        observerTrainings.observe(element)
    } else {
        return
    }
})
